import React from 'react';
import PropTypes from 'prop-types';

/** Label + control — proto uses inline (label beside field) for CRC/Author/Search. */
export function LabeledControl({
  label,
  children,
  className = '',
  layout = 'stack',
}) {
  return (
    <label
      className={`onyx-labeled-control onyx-labeled-control--${layout} ${className}`.trim()}
      data-testid="onyx-labeled-control"
    >
      <span className="onyx-labeled-control__label">{label}</span>
      <span className="onyx-labeled-control__field">{children}</span>
    </label>
  );
}

LabeledControl.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  layout: PropTypes.oneOf(['stack', 'inline']),
};
